import React, { useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

import CurrencyControl from '../../../app/components/CurrencyControl';
import * as mathUtils from '../../../utils/mathUtils';

import { WithdrawalCommentSelector } from './WithdrawalCommentSelector';

interface WithdrawalModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: (amount: string, comment?: string) => void;
}

export const WithdrawalModal: React.FC<WithdrawalModalProps> = ({
  show,
  onHide,
  onConfirm,
}) => {
  const [amount, setAmount] = useState('');
  const [comment, setComment] = useState('');

  const handleConfirm = () => {
    if (!amount || mathUtils.subtract(amount, 0.01) < 0) {
      return;
    }
    onConfirm(amount, comment.trim() || undefined);
    setAmount('');
    setComment('');
  };

  const handleHide = () => {
    setAmount('');
    setComment('');
    onHide();
  };

  return (
    <Modal show={show} onHide={handleHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Wyprowadź poza system</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="info">
          Pamiętaj, aby zapisać zmiany na zakładce z powiązaniami.
        </Alert>
        <Form.Group>
          <Form.Label>Kwota</Form.Label>
          <CurrencyControl
            allowNegative={false}
            decimalScale={2}
            value={amount}
            onChange={v => setAmount(v || '')}
          />
        </Form.Group>
        <Form.Group className="mt-3">
          <Form.Label>Komentarz</Form.Label>
          <WithdrawalCommentSelector value={comment} onChange={setComment} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleHide}>
          Anuluj
        </Button>
        <Button
          variant="warning"
          onClick={handleConfirm}
          disabled={!amount || mathUtils.subtract(amount, 0.01) < 0}
        >
          Wyprowadź
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
